import React, { Fragment, useEffect, useState } from "react";
import TrashCan from "../assets/images/trash.svg";
import Tick from "../assets/images/check.svg";
import Cross from "../assets/images/x.svg";
import arrowRight from "../assets/images/arrow-right-white.svg";
import { assign, unassign } from "../Store/api/activities";
import { byBook, remove as deleteActivity } from "../Store/api/activities";
import { replaceActivity } from "../Store/entities/book";
import { useDispatch, useSelector } from "react-redux";
const CustomEvent = ({
  event,
  isDragging,
  setIsDragging,
  draggedEvent,
  setDraggedEvent,
  position,
  index,
  setPosition,
  setSelectedActivity,
  // selectedActivity,
}) => {
  if (isDragging) {
  }

  const [isHovering, setIsHovering] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { book } = useSelector((state) => state.entities);
  let timeoutId = null;
  const dispatch = useDispatch();
  // Add your custom event rendering logic here
  return (
    <Fragment>
      <div
        className={`custom-event ${
          event.assigned ? "assigned-event" : ""
        } moving
        ${isDragging && draggedEvent._id === event._id ? "ghosted" : ""}
        `}
        onMouseEnter={(e) => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            setIsHovering(true);
          }, 1000);
        }}
        onMouseLeave={(e) => {
          clearTimeout(timeoutId);
          setIsDeleting(false);
          setIsHovering(false);
        }}
        onMouseDown={(e) => {
          setIsDragging(true);
          setDraggedEvent(event);
          setPosition(e.clientX, e.clientY);
        }}
      >
        <div className="event-title">{event.title}</div>

        {isHovering && (
          <div
            className={`hovered-event ${
              event.assigned ? "assigned-event" : ""
            }`}
          >
            {!isDeleting ? (
              <img
                src={TrashCan}
                alt="trash"
                className="trash cursor"
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsDeleting(true);
                }}
              />
            ) : (
              <div
                className="event-options-wrapper"
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
              >
                <img
                  className="cursor"
                  src={Tick}
                  onMouseDown={(e) => {
                    e.stopPropagation();
                  }}
                  alt="go"
                  style={{ width: ".7rem", height: ".7rem" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // dispatch(
                    //   deleteActivity({
                    //     id: event._id,
                    //     onSuccess: (res) => {
                    //       dispatch(
                    //         byBook({
                    //           id: book._id,
                    //           onSuccess: (res) => {},
                    //         })
                    //       );
                    //       dispatch(
                    //         replaceActivity({
                    //           activity: {
                    //             ...event,
                    //             assigned: false,
                    //             assignedDate: null,
                    //           },
                    //           index: book.activities.findIndex(
                    //             (e) => e._id === event._id
                    //           ),
                    //         })
                    //       );
                    //     },
                    //   })
                    // );
                    dispatch(
                      unassign({
                        id: event._id,
                        onSuccess: (res) => {
                          dispatch(
                            replaceActivity({
                              activity: {
                                ...event,
                                assigned: false,
                                assignedDate: null,
                              },
                              index: book.activities.findIndex(
                                (e) => e._id === event._id
                              ),
                            })
                          );
                        },
                        onError: (err) => {
                          alert(
                            err.response.data.message || "Something went wrong"
                          );
                        },
                      })
                    );
                  }}
                />
                <img
                  src={Cross}
                  style={{ width: ".7rem", height: ".7rem" }}
                  className="cursor"
                  alt="cross"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsDeleting(false);
                  }}
                />
              </div>
            )}
            <div className="event-body">
              <h2>{event.title}</h2>
              <span>
                {event.score} points | {event.questions.length} question
              </span>
            </div>

            <img
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
              src={arrowRight}
              alt="arrow-right"
              className="arrow-right cursor"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedActivity(event);
              }}
            />
          </div>
        )}
      </div>
      {isDragging && draggedEvent._id === event._id && (
        <div
          style={{
            position: "fixed",
            top: `${position.top}px`,
            left: `${position.left + 2}px`,
            height: "15px",
            zIndex: "9999",
          }}
          className={`custom-event ghost-event ${
            event.assigned ? "assigned-event" : ""
          }`}
        >
          <div className="event-title">{event.title}</div>
        </div>
      )}
    </Fragment>
  );
};

export default CustomEvent;
